import {
    FeedbackActionType,
    FEEDBACKS,
    CLEAR_FEEDBACKS,
} from './feedback.actions';
import Feedback from '../../@types/feedback.interface';

interface IState {
    feedbacks: Feedback[] | null;
}

const INITIAL_STATE: IState = {
    feedbacks: null,
};

export default function feedbackReducer(
    state: IState = INITIAL_STATE,
    action: FeedbackActionType
): IState {
    switch (action.type) {
        case FEEDBACKS:
            return {
                ...state,
                feedbacks: action.payload.feedbacks,
            };
        case CLEAR_FEEDBACKS:
            return {
                ...state,
                feedbacks: null,
            };
        default:
            return state;
    }
}
